
const CampaignCardStyles = (theme) => ({
	typography: {
		marginTop: 20,
		marginBottom: 10,
	},
	margin: {
		marginTop: 20,
		marginBottom: 10,
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit
	},
	paper: {
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`
	}
});

export default CampaignCardStyles;
